<template>
  <div class="charts-table">
    <div
      class="charts-table__wrapper"
      :class="{
        'charts-table__wrapper--scroll-left': canScrollLeft,
        'charts-table__wrapper--scroll-right': canScrollRight,
      }"
    >
      <button
        v-if="canScrollLeft"
        class="charts-table__arrow charts-table__arrow--left"
        @click="scrollLeft"
      ></button>

      <swiper
        v-bind="swiperOption"
        class="charts-table__row"
        ref="swiper"
        @swiper="onSwiperReady"
        @transitionEnd="onTransitionEnd"
        @touchEnd="onTouchEnd"
        @resize="onTransitionEnd"
        @observerUpdate="onTransitionEnd"
        @reachBeginning="onReachBeginning"
        @reachEnd="onReachEnd"
      >
        <swiper-slide
          v-for="item in contracts"
          :key="item.contractId"
          :class="{
            'charts-table__row-item': true,
            'charts-table__row-item--with-image': showImage,
          }"
        >
          <form-checkbox
            :color="checkboxColor(item)"
            :name="contractName(item)"
            v-model="item.checked"
            @change="onChange(item, $event)"
          >
            <div class="charts-table__item">
              <div
                v-if="showImage"
                :style="imageStyleModifiers(item)"
                class="charts-table__item-image"
              ></div>
              <div class="charts-table__item-label">
                <div v-contract-name>
                  {{ item.contractName }}
                </div>
              </div>
            </div>
          </form-checkbox>
        </swiper-slide>
      </swiper>

      <button
        v-if="canScrollRight"
        class="charts-table__arrow charts-table__arrow--right"
        @click="scrollRight"
      ></button>
    </div>
  </div>
</template>

<script src="./table.js"></script>
<style src="./table.scss" lang="scss"></style>
